define([], function() {
    'use strict';

    function isNumber(value) {
        return typeof value === 'number';
    }

    return isNumber;
});
